export const TOOLTIP = {
  settings: 'settings',
  share: 'share',
};
